import axios from 'services/http';

export const getter = <T>([url, params]: [url: string, params: any]) => {
  return axios.get<T>(url, { params: params }).then((res: any) => res.data);
};

export const poster = <T>([url, params]: [url: string, params: any]) =>
  axios.post<T>(url, params).then((res: any) => res.data);
